export enum ReportColumn {
  EXTERNAL_REFERENCE_ID = 'externalReferenceId',
  CURRENCY = 'currency',
  BRAND_NAME = 'brandName',

  EXPERIENCE_NAME = 'experienceName',
  EXPERIENCE_DATE = 'experienceDate',
  TRANSACTION_DATE = 'transactionDate',
  TRANSACTION_MONTH = 'transactionMonth',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  CONFIRMATION_CODE = 'confirmationCode',
  PAYMENT_TYPE = 'paymentType',
  PAYMENT_METHOD = 'paymentMethod',
  ACCOUNT = 'accountNumber',
  DESCRIPTION = 'description',
  DURATION = 'duration',
  HOST = 'hostName',
  TOTAL = 'total',
  DISCOUNT_AMOUNT = 'discountAmount',
  SUBTOTAL = 'subtotal',
  GROSS_REVENUE = 'grossRevenue',
  NET_REVENUE = 'netRevenue',
  TAXES = 'taxes',
  TOTAL_PAID = 'totalPaid',
  FX_ADJUSTMENT = 'fxAdjustment',
  HOST_PAYOUT = 'hostPayout',
  PROMOTER_PAYOUT = 'promoterPayout',
  CREDIT_CARD = 'creditCardFee',
  STRIPE_FX_FEE = 'stripeFxFee',
  WAY_FEE = 'wayFee',
  PARTNER_PAYOUT = 'partnerPayout',
  TRANSACTION_ROLE = 'transactionRole',
  PARTNER_NAME = 'partnerName',
  NET_DEPOSITED = 'netDeposited',
  QUANTITY = 'quantity',
  DISCOUNT_CODE = 'discountCode',
  DATE_DEPOSITED = 'dateDeposited',
  NOTES = 'notes',
  INTERNAL_NOTES = 'internalNotes',
  RESERVATION_ID = 'reservationId',
  CART_ID = 'cartId',
  CREATED_BY = 'createdBy',

  PRICING_LABEL = 'pricingLabel',
  EMAIL = 'email',
  PHONE = 'phone',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  CUSTOM_QUESTION_ANSWERS = 'customQuestionAnswer',
  CATEGORY = 'category',
  LISTING_STATUS = 'listingStatus',
  BOOKING_URL = 'bookingUrl',
  PROMOTER_SOURCE = 'promoterSource',
  APPROVED_PROMOTERS = 'approvedPromoters',
  TOTAL_PARTICIPANTS = 'totalParticipants',
  REFUNDS = 'refunds',
  BOOKING_STATUS = 'bookingStatus',
  CHECK_IN_STATUS = 'checkInStatus',
  GUEST_NOTES = 'guestNotes',

  CUSTOM_QUESTIONS = 'customQuestions',
  PRICE_TIERS = 'priceTiers',
  ADD_ONS = 'addOns',

  ITEM_TYPE = 'itemType',
}

export enum ReportSortBy {
  START_DATE_TIME = 'startDateTime',
  BOOKED_AT = 'bookedAt',
  TRANSACTION_DATE = 'transactionDate',
}

export enum TransactionType {
  CHARGE = 'charge',
  LOYALTY_POINTS = 'loyaltyPoints',
  TRANSFER = 'transfer',
  REFUND = 'refund',
  REVERSE = 'reverse',
  DEBIT = 'debit',
  VOID = 'void',
}

export enum ReportTransactionRole {
  OWN_EXPERIENCE = 'Own Experience',
  SELLING_PARTNER_EXPERIENCE = 'Selling Partner Experience',
  PARTNER_SELLING_MY_EXPERIENCE = 'Partner Selling My Experience',
}
